import { api } from './api';
import type { GnRole } from '../components/gn/GnContext';

export interface GnMediaUploadResult {
  assetId: number;
  mediaType: 'AUDIO' | 'VIDEO';
  durationSeconds: number;
}

/**
 * GN recording upload + playback (spec 046 FR-004, contracts/student-gn-api.md §Media).
 * Uploads go to R2 via the backend; playback uses short-lived presigned URLs, owner-only.
 */
export async function uploadRecording(
  role: GnRole,
  courseId: number,
  nodeId: number | null,
  file: Blob,
  mediaType: 'AUDIO' | 'VIDEO',
  durationSeconds: number,
): Promise<GnMediaUploadResult> {
  const form = new FormData();
  form.append('file', file, mediaType === 'AUDIO' ? 'recording.webm' : 'recording-video.webm');
  form.append('mediaType', mediaType);
  form.append('durationSeconds', String(Math.round(durationSeconds)));
  form.append('courseId', String(courseId));
  if (nodeId != null) form.append('nodeId', String(nodeId));

  const response = await api.post<{ data: GnMediaUploadResult }>(`/api/${role}/gn/media`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data.data;
}

export async function getPlaybackUrl(role: GnRole, assetId: number): Promise<string> {
  const response = await api.get<{ data: { url: string } }>(`/api/${role}/gn/media/${assetId}/url`);
  return response.data.data.url;
}
